import React, {  useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CloseIcon, SwapGrayIcon, SwapIcon } from "../../../../assets/images";
import { RadioTypes } from "../../../../commonTypes/universalTypes";
import { RadioContainer } from "../../../commons";

export const BILL_OF_MATERIAL_OPTIONS: RadioTypes[] = [
  {
    id: "",
    _id: "default",
    name: "Recently Modified First",
  },
  {
    id: "primary_item_name#$#asc",
    _id: "asc",
    name: "Primary Item - Ascending",
  },
  {
    id: "primary_item_name#$#desc",
    _id: "desc",
    name: "Primary Item - Descending",
  },
  {
    id: "document_number#$#asc",
    _id: "asc",
    name: "Document Number - Ascending",
  },
  {
    id: "document_number#$#desc",
    _id: "desc",
    name: "Document Number - Descending",
  },
  {
    id: "bom_date#$#asc",
    _id: "asc",
    name: "Manufacturing Date - Ascending",
  },
  {
    id: "bom_date#$#desc",
    _id: "desc",
    name: "Manufacturing Date - Descending",
  },
];
export const SAVED_TEMPLATE_SORTING_OPTION: RadioTypes[] = [
  {
    id: "",
    _id: "default",
    name: "Recently Modified First",
  },
  {
    id: "primary_item_name#$#asc",
    _id: "asc",
    name: "Primary Item - Ascending",
  },
  {
    id: "primary_item_name#$#desc",
    _id: "desc",
    name: "Primary Item - Descending",
  },
  {
    id: "template_id#$#asc",
    _id: "asc",
    name: "Template ID - Ascending",
  },
  {
    id: "template_id#$#desc",
    _id: "desc",
    name: "Template ID - Descending",
  },
];
type AppProps = {
  sortingData: string;
  type?: string;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  setSortingData: React.Dispatch<React.SetStateAction<string>>;
};

const BOMSorting = ({
  sortingData,
  type,
  setOffset,
  setSortingData,
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={<Tooltip id="button-view-filter-invoice">Sorting</Tooltip>}
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            toggle || sortingData !== ""
              ? {
                  color: "#dd4433",
                  border: "1px solid #dd4433",
                  backgroundColor: "#fff6f5",
                }
              : { border: "1px solid#bfcbe1" }
          }
          outline
        >
          <img src={toggle ? SwapIcon : SwapGrayIcon} alt="" />
        </DropdownToggle>
      </OverlayTrigger>

      <DropdownMenu right>
        <div className="download-dropdown p-2" style={{ minWidth: "300px" }}>
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Sort By</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />

          <div className="mt-4">
            <div>
              <RadioContainer
                optionsList={
                  type
                    ? SAVED_TEMPLATE_SORTING_OPTION
                    : BILL_OF_MATERIAL_OPTIONS
                }
                handleSetRadioValue={(e: any) => {
                  setOffset(0);
                  setSortingData(e);
                  setToggle(!toggle);
                }}
                radioValue={sortingData}
                alignment="vertical"
                backGround={true}
              />
            </div>
          </div>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default BOMSorting;
